/**
 * Public website module — "House Prices". Same postcode → AI price
 * estimate tool as the agent dashboard's "House Prices" section
 * (HousePricesTool, in publicMode so it hits the unauthenticated
 * /api/public/house-prices/estimate endpoint), plus a configurable CTA
 * button linking to any site page.
 */
import HousePricesTool from "@/components/property-admin/HousePricesTool";

function ctaHref(slug) {
  if (slug === null || slug === undefined || slug === "") return null;
  return slug.startsWith("/") ? slug : `/${slug}`;
}

export default function HousePricesModule({ config = {} }) {
  const href = ctaHref(config.cta_page_slug);
  const thankYouCtaHref = ctaHref(config.thankyou_cta_page_slug);
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-6" data-testid="house-prices-public-module">
      <div className="text-center space-y-2">
        {config.heading && (
          <h2 className="text-2xl sm:text-3xl font-serif font-medium" data-testid="house-prices-module-heading">
            {config.heading}
          </h2>
        )}
        {config.subheading && (
          <p className="text-muted-foreground" data-testid="house-prices-module-subheading">
            {config.subheading}
          </p>
        )}
      </div>

      <HousePricesTool
        publicMode
        thankYouCtaText={config.thankyou_cta_text}
        thankYouCtaHref={thankYouCtaHref}
      />

      {config.cta_text?.trim() && href && (
        <div className="text-center pt-2">
          <a
            href={href}
            className="inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200 shadow hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap px-8 py-4 text-lg"
            style={{
              backgroundColor: "var(--button-bg, var(--primary, #2f4f4f))",
              color: "var(--button-text, #ffffff)",
              borderRadius: "999px",
            }}
            data-testid="house-prices-module-cta"
          >
            {config.cta_text}
          </a>
        </div>
      )}
    </div>
  );
}
